import { Button, Tooltip } from "antd";
import React from "react";
import { PrinterFilled, TableOutlined } from "@ant-design/icons";

export const ReportButtons = ({ onPrint, onDownload }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
      }}
    >
      <Tooltip
        placement="topLeft"
        title="Click to preview/print report"
        key={"print"}
      >
        <Button
          key="print"
          type="primary"
          icon={<PrinterFilled />}
          onClick={onPrint}
        />
      </Tooltip>
      <Tooltip
        placement="topLeft"
        title="Click to download data in CSV"
        key={"download"}
      >
        <Button
          key="download"
          type="primary"
          icon={<TableOutlined />}
          onClick={onDownload}
        />
      </Tooltip>
    </div>
  );
};
